import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import useIsMobile from "customHooks/useIsMobile";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import openIcon from "assets/images/svg/arrow-white.svg";
import NGIDropdownButton from "components/Common/buttons/NGIDropdownButton";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",

    "&> div:not(:first-child)": {
      borderLeft: "1px solid rgba(0, 0, 0, 0.08)",
    },

    "& div": {
      borderRadius: 0,
    },

    "&>:first-child": {
      borderRadius: "5px 0 0 5px",
    },

    "&>:last-child": {
      borderRadius: "0 5px 5px 0",
    },

    "&>:last-child:first-child": {
      borderRadius: "5px 5px 5px 5px",
    },
  },
  primary: {
    "&>.dropdown": {
      border: 0,
      background: "linear-gradient(180deg, #00C2FF 0%, #0085FF 100%)",

      "&>span": {
        padding: 0,
        border: 0,

        "&>div": {
          background: "transparent",
        },
      },
    },

    "&>:first-child": {
      borderRadius: "30px 0 0 30px",
    },

    "&>:last-child": {
      borderRadius: "0 30px 30px 0",
    },

    "&>:last-child:first-child": {
      borderRadius: 30,
    },
  },
});

const ButtonGroupContainer = ({ children, color, hasMobileView = false }) => {
  const classes = useStyles();
  const isMobile = useIsMobile();
  if (isMobile && hasMobileView) {
    const buttonsPros = (children.length ? children : [children])
      .filter(item => item?.props)
      .map(item => ({
        label: item.props?.tooltipTitle,
        callback: item.props?.handleClick,
        hideRoles: item.props?.hideRoles,
        icon: item.props?.icon,
      }));
    return (
      <NGIDropdownButton
        hasMobileView
        position="left"
        toggleEl={<ButtonGroup color={color} icon={openIcon} />}
        menuItems={buttonsPros}
      />
    );
  }
  return <div className={classnames(classes.root, color === "primary" && classes.primary)}>{children}</div>;
};
export default ButtonGroupContainer;
